'use strict';

var cov_n9vluxf2i = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/auth/auth.component.js',
      hash = '1f699a5934651ada41fc4f6825449ce7e4c2542b',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/auth/auth.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 27
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 29
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 35
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 19
        }
      },
      '4': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 25
        }
      },
      '5': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 29
        }
      },
      '6': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 20
        }
      },
      '7': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      '8': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 23,
          column: 6
        }
      },
      '9': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 37,
          column: 7
        }
      },
      '10': {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 32,
          column: 67
        }
      },
      '11': {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 36,
          column: 7
        }
      },
      '12': {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 24
        }
      },
      '13': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 33
        }
      },
      '14': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 57,
          column: 11
        }
      },
      '15': {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 52,
          column: 67
        }
      },
      '16': {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 27
        }
      },
      '17': {
        start: {
          line: 55,
          column: 10
        },
        end: {
          line: 55,
          column: 37
        }
      },
      '18': {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 56,
          column: 40
        }
      },
      '19': {
        start: {
          line: 62,
          column: 0
        },
        end: {
          line: 124,
          column: 5
        }
      },
      '20': {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 123,
          column: 6
        }
      },
      '21': {
        start: {
          line: 79,
          column: 21
        },
        end: {
          line: 79,
          column: 66
        }
      },
      '22': {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 83,
          column: 9
        }
      },
      '23': {
        start: {
          line: 82,
          column: 10
        },
        end: {
          line: 82,
          column: 22
        }
      },
      '24': {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 42
        }
      },
      '25': {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 48
        }
      },
      '26': {
        start: {
          line: 101,
          column: 22
        },
        end: {
          line: 101,
          column: 32
        }
      },
      '27': {
        start: {
          line: 103,
          column: 24
        },
        end: {
          line: 107,
          column: 10
        }
      },
      '28': {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 119,
          column: 13
        }
      },
      '29': {
        start: {
          line: 112,
          column: 12
        },
        end: {
          line: 112,
          column: 81
        }
      },
      '30': {
        start: {
          line: 113,
          column: 12
        },
        end: {
          line: 113,
          column: 84
        }
      },
      '31': {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 115,
          column: 43
        }
      },
      '32': {
        start: {
          line: 118,
          column: 12
        },
        end: {
          line: 118,
          column: 45
        }
      },
      '33': {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 29
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 69
          },
          end: {
            line: 9,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 24,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        loc: {
          start: {
            line: 30,
            column: 28
          },
          end: {
            line: 38,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 31,
            column: 19
          }
        },
        loc: {
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 37,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 58,
            column: 3
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        },
        loc: {
          start: {
            line: 50,
            column: 14
          },
          end: {
            line: 54,
            column: 9
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 54,
            column: 11
          },
          end: {
            line: 54,
            column: 12
          }
        },
        loc: {
          start: {
            line: 54,
            column: 20
          },
          end: {
            line: 57,
            column: 9
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 71,
            column: 26
          },
          end: {
            line: 71,
            column: 27
          }
        },
        loc: {
          start: {
            line: 71,
            column: 63
          },
          end: {
            line: 124,
            column: 3
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 110,
            column: 11
          }
        },
        loc: {
          start: {
            line: 110,
            column: 29
          },
          end: {
            line: 116,
            column: 11
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 117,
            column: 10
          },
          end: {
            line: 117,
            column: 11
          }
        },
        loc: {
          start: {
            line: 117,
            column: 27
          },
          end: {
            line: 119,
            column: 11
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 30,
            column: 11
          },
          end: {
            line: 30,
            column: 26
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 26
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 78,
            column: 11
          },
          end: {
            line: 78,
            column: 26
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 26
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0
    },
    b: {
      '0': [0],
      '1': [0, 0],
      '2': [0],
      '3': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthComponent = function () {
  function AuthComponent($window, $cookies, $timeout, AuthService, lodash, API) {
    _classCallCheck(this, AuthComponent);

    ++cov_n9vluxf2i.f[0];
    ++cov_n9vluxf2i.s[0];

    this.$window = $window;
    ++cov_n9vluxf2i.s[1];
    this.$timeout = $timeout;
    ++cov_n9vluxf2i.s[2];
    this.authService = AuthService;
    ++cov_n9vluxf2i.s[3];
    this.api = API;
    ++cov_n9vluxf2i.s[4];
    this.lodash = lodash;
    ++cov_n9vluxf2i.s[5];
    this.$cookies = $cookies;
  }

  _createClass(AuthComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_n9vluxf2i.f[1];
      ++cov_n9vluxf2i.s[6];

      this.setFocus();

      ++cov_n9vluxf2i.s[7];
      this.credentials = {
        username: null,
        instance: this.$cookies.get('instance'),
        password: null
      };

      ++cov_n9vluxf2i.s[8];
      this.request = {
        fetching: false,
        error: null
      };
    }

    /**
     * Cette méthode permet d'assigner le focus.
     */

  }, {
    key: 'setFocus',
    value: function setFocus() {
      var _this = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_n9vluxf2i.b[0][0], 'username');
      ++cov_n9vluxf2i.f[2];
      ++cov_n9vluxf2i.s[9];

      this.$timeout(function () {
        ++cov_n9vluxf2i.f[3];

        var element = (++cov_n9vluxf2i.s[10], _this.$window.document.querySelector('#' + id));

        ++cov_n9vluxf2i.s[11];
        if (element) {
          ++cov_n9vluxf2i.b[1][0];
          ++cov_n9vluxf2i.s[12];

          element.focus();
        } else {
          ++cov_n9vluxf2i.b[1][1];
        }
      });
    }

    /**
     * Envoi du formulaire
     */

  }, {
    key: 'doSubmit',
    value: function doSubmit() {
      var _this2 = this;

      ++cov_n9vluxf2i.f[4];
      ++cov_n9vluxf2i.s[13];

      this.request.fetching = true;

      ++cov_n9vluxf2i.s[14];
      this.authService.auth(this.credentials).then(function () {
        ++cov_n9vluxf2i.f[5];
        ++cov_n9vluxf2i.s[15];

        // Store instance.
        _this2.$cookies.put('instance', _this2.credentials.instance);
        ++cov_n9vluxf2i.s[16];
        _this2.onSuccess();
      }, function (error) {
        ++cov_n9vluxf2i.f[6];
        ++cov_n9vluxf2i.s[17];

        _this2.request.error = error;
        ++cov_n9vluxf2i.s[18];
        _this2.request.fetching = false;
      });
    }
  }]);

  return AuthComponent;
}();

++cov_n9vluxf2i.s[19];


angular.module('app').component('auth', {
  bindings: {
    onSuccess: '&'
  },
  controller: AuthComponent,
  templateUrl: 'app/auth/auth.component.html'
}).factory('AuthService', function ($http, $window, $q, lodash, API) {
  ++cov_n9vluxf2i.f[7];
  ++cov_n9vluxf2i.s[20];

  return {

    /**
     * Retourne l'utilisateur courant.
     */

    user: function user() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_n9vluxf2i.b[2][0], null);

      var user = (++cov_n9vluxf2i.s[21], angular.fromJson($window.sessionStorage.user));

      ++cov_n9vluxf2i.s[22];
      if (property === null) {
        ++cov_n9vluxf2i.b[3][0];
        ++cov_n9vluxf2i.s[23];

        return user;
      } else {
        ++cov_n9vluxf2i.b[3][1];
      }

      ++cov_n9vluxf2i.s[24];
      return lodash.get(user, property);
    },


    /**
     * Retourne le sessionId.
     */

    sessionId: function sessionId() {
      ++cov_n9vluxf2i.s[25];

      return $window.sessionStorage.sessionId;
    },


    /**
     * Méthode d'authentification
     */

    auth: function auth(credentials) {
      var defer = (++cov_n9vluxf2i.s[26], $q.defer());

      var request = (++cov_n9vluxf2i.s[27], $http({
        url: API + '/auth',
        method: 'POST',
        data: credentials
      }));

      ++cov_n9vluxf2i.s[28];
      request.then(function (responseSuccess) {
        ++cov_n9vluxf2i.f[8];
        ++cov_n9vluxf2i.s[29];

        // Store User.
        $window.sessionStorage.sessionId = responseSuccess.data.access_token;
        ++cov_n9vluxf2i.s[30];
        $window.sessionStorage.user = angular.toJson(responseSuccess.data.user);

        ++cov_n9vluxf2i.s[31];
        defer.resolve(responseSuccess);
      }, function (responseError) {
        ++cov_n9vluxf2i.f[9];
        ++cov_n9vluxf2i.s[32];

        defer.reject(responseError.data);
      });

      ++cov_n9vluxf2i.s[33];
      return defer.promise;
    }
  };
});